/* Mirumi motion — restrained, opt-out aware.
   1. Scroll reveals: fade/rise elements marked .mru-reveal as they enter view.
   2. Behaviour clips: play looping muted videos only while on screen, and
      only if the visitor hasn't asked for reduced motion.
   Everything degrades to a static, fully-visible page without JS. */
(function () {
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveals ---- */
  var reveals = Array.prototype.slice.call(document.querySelectorAll('.mru-reveal'));
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var revObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    reveals.forEach(function (el) { revObserver.observe(el); });
  }

  /* ---- Behaviour / ambient clips ---- */
  var videos = Array.prototype.slice.call(document.querySelectorAll('[data-mru-video]'));
  if (!videos.length) return;

  if (reduceMotion) {
    // Leave the poster frame showing; never autoplay.
    videos.forEach(function (v) { v.removeAttribute('autoplay'); });
    return;
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(function (v) { safePlay(v); });
    return;
  }

  var vidObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          safePlay(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    },
    { threshold: 0.25 }
  );
  videos.forEach(function (v) { vidObserver.observe(v); });

  function safePlay(v) {
    var p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () { /* autoplay blocked; poster stays */ });
    }
  }
})();
